import autoTable from "jspdf-autotable";
import { DateisValid } from "../../../utils/commonComponent/errorAlert";
import { config, waterMarkImgConfig } from "./datasheetConfig";
import { observationSheetConfigData } from "./datasheetPrint";

const Logo = "/image/compnay_logo.png";
const DraftImage = "/image/draft.png";
const LogoImage = "/image/WatermarkLogo.png";

export const getHeaderHeight = () =>
  config.borderMargin +
  config.headerTableHeight +
  config.headerTitleHeight +
  config.headerSecondTableHeight +
  config.headerSpacing;

export const getFooterHeight = () =>
  config.borderMargin + config.footerTableHeight;

// --- Common function to draw text ---
export const drawText = (doc, text, x, y, options = {}) => {
  const { align = "left", bold = false, fontSize = config.fontSize } = options;
  doc.setFont("helvetica", bold ? "bold" : "normal");
  doc.setFontSize(fontSize);
  doc.text(text, x, y, { align });
};

// Draw border around content area
export const drawBorder = (doc) => {
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);

  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();
  const topY = getHeaderHeight();
  const bottomMargin = getFooterHeight();

  doc.rect(
    config.margin,
    topY,
    totalWidth - config.margin * 2,
    totalHeight - topY - bottomMargin
  );
};

// Draw dynamic header (called for each page)
export const drawHeaderTable = (doc, observationSheet) => {
  let localY = config.borderMargin;
  const pageWidth = doc.internal.pageSize.getWidth();
  const totalPageWidth = pageWidth - config.margin * 2;

  // --- First Header Table (Logo + Title + Document Info) ---
  const tableRows = [
    [
      {
        content: "", // Logo placeholder
        rowSpan: 2,
        styles: { halign: "center", valign: "middle" },
      },
      {
        content: `LABCITY CALIBRATION SERVICES\nObservation Sheet - ${
          observationSheet?.materialTestings_testName || ""
        }`,
        rowSpan: 2,
        styles: {
          halign: "center",
          valign: "middle",
          fontStyle: "bold",
        },
      },
      {
        content: "Document Number",
        styles: { halign: "left", valign: "middle", fontStyle: "bold" },
      },
      {
        content: observationSheet?.documentNumber || "-",
        styles: { halign: "left", valign: "middle" },
      },
    ],
    [
      {
        content: "Issue No. / Date",
        styles: { halign: "left", valign: "middle", fontStyle: "bold" },
      },
      {
        content: `${observationSheet?.issueNumber || "-"} / ${
          DateisValid(observationSheet?.issueDate) || "-"
        }`,
        styles: { halign: "left", valign: "middle" },
      },
    ],
  ];

  const columnPercentages = [20, 40, 20, 20];
  const columnWidths = columnPercentages.map((p) => (totalPageWidth * p) / 100);

  autoTable(doc, {
    startY: localY,
    margin: { left: config.margin, right: config.margin },
    body: tableRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 3,
      halign: "center",
      valign: "middle",
      fillColor: false,      
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
    },
    didDrawCell: (data) => {
      if (data.column.index === 0 && data.row.index === 0) {
        const cell = data.cell;
        const maxWidth = cell.width * 0.9;
        const maxHeight = cell.height * 0.9;
        const aspectRatio = 2;
        let w = maxWidth;
        let h = w / aspectRatio;
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }
        const x = cell.x + (cell.width - w) / 2;
        const y = cell.y + (cell.height - h) / 2;
        doc.addImage(Logo, "PNG", x, y, w, h);
      }
    },
  });

  localY = doc.lastAutoTable.finalY;

  // --- Title Text ---
  drawText(
    doc,
    `Observation Sheet of ${observationSheet?.materialTestings_testName || ""}`,
    pageWidth / 2,
    localY + 15,
    { align: "center", bold: true, fontSize: config.fontSize + 2 }
  );

  localY = localY + 25;

  const newTableRows = [
    [
      {
        content: "Job No",
        styles: { halign: "left", fontStyle: "bold", valign: "middle" },
      },
      { content: observationSheet?.jobRegister_jobNumber || "", styles: { halign: "left", valign: "middle" } },
      {
        content: "Lab Reference No.",
        styles: { halign: "left", fontStyle: "bold", valign: "middle" },
      },
      {
        content: observationSheet?.inward_labReferenceNo || "-",
        styles: { halign: "left", valign: "middle" },
      },
      {
        content: "Testing No.",
        styles: { halign: "left", fontStyle: "bold", valign: "middle" },
      },
      {
        content: observationSheet?.observationSheet_testNumber || "",
        styles: { halign: "left", valign: "middle" },
      },
    ],
    [
      {
        content: "Start Date Testing",
        styles: { halign: "left", fontStyle: "bold", valign: "middle" },
      },
      { content: DateisValid(observationSheet?.observationSheet_startTestingDate), styles: { halign: "left", valign: "middle" },
       colSpan:2
    },
      {
        content: "End Date Testing",
        styles: { halign: "left", fontStyle: "bold", valign: "middle" },
      },
      {
        content: DateisValid(observationSheet?.observationSheet_endTestingDate) || "-",
        styles: { halign: "left", valign: "middle" },
        colSpan:2
      },
    ],
  ];

  const columnPercentagesTable2 = [15, 15, 17, 23, 15, 15];
  const columnWidthsTable2 = columnPercentagesTable2.map(
    (p) => (totalPageWidth * p) / 100
  );

  autoTable(doc, {
    startY: localY,
    margin: { left: config.margin, right: config.margin },
    body: newTableRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 3,
      halign: "center",
      valign: "middle",
      fillColor: false,      
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: columnWidthsTable2[0] },
      1: { cellWidth: columnWidthsTable2[1] },
      2: { cellWidth: columnWidthsTable2[2] },
      3: { cellWidth: columnWidthsTable2[3] },
      4: { cellWidth: columnWidthsTable2[4] },
      5: { cellWidth: columnWidthsTable2[5] },
    },
  });
//   return doc.lastAutoTable.finalY;
};

export const drawFooterTable = (doc, observationSheet) => {
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const usableWidth = pageWidth - config.margin * 2;
  const startY = pageHeight - getFooterHeight() + 5;

  const testedBy = {
    sign: observationSheet?.testedBy_userSign || null,
    name: observationSheet?.testedBy_userName || "-",
    designation: observationSheet?.testedBy_hrDesignation || "-",
  };

  const approvedBy = {
    sign: observationSheet?.approvedBy_userSign || null,
    name: observationSheet?.approvedBy_userName || "-",
    designation: observationSheet?.approvedBy_hrDesignation || "-",
  };

  // Only strings (no images) go into content
  const body = [
    [{ content: "Signature: ", styles: { minCellHeight: 30 } }, { content: "Signature: ", styles: { minCellHeight: 30 } }],
    [{ content: `Name: ${testedBy.name}` }, { content: `Name: ${approvedBy.name}` }],
    [{ content: `Designation: ${testedBy.designation}` }, { content: `Designation: ${approvedBy.designation}` }],
    [{ content: "Tested By", styles: { fontStyle: "bold" } }, { content: "Approved By", styles: { fontStyle: "bold" } }],
  ];

  autoTable(doc, {
    startY,
    body,
    theme: "grid",
    margin: { left: config.margin, right: config.margin, bottom: config.borderMargin},
    styles: {
      fontSize: config.fontSize - 1,
      cellPadding: 4,
      textColor: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
      valign: "middle",
      fontStyle: "bold"
    },
    columnStyles: {
      0: { cellWidth: usableWidth / 2 },
      1: { cellWidth: usableWidth / 2 },
    },
    didDrawCell: (data) => {
      if (data.row.index === 0) {
        const cell = data.cell;
        const image =
          data.column.index === 0 ? testedBy.sign : approvedBy.sign;

        if (image) {
          const imgWidth = 40;
          const imgHeight = 20;
          const x = cell.x + (cell.width - imgWidth) / 2;
          const y = cell.y + (cell.height - imgHeight) / 2;
          try {
            doc.addImage(image, "PNG", x, y, imgWidth, imgHeight);
          } catch (err) {
            console.warn("Image error:", err);
          }
        }
      }
    },
  });
};

// Draw drawWaterMarkImg
export const drawWaterMarkImg = (doc) => {
  try {
    const props = observationSheetConfigData?.observationSheetProps || {};
    const { letterHead, draft } = props;

    const pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight();
    const { logoWidth: lw, logoHeight: lh } = waterMarkImgConfig;
    const dx = (pw - 450) / 2, dy = (ph - 500) / 2, lx = (pw - lw) / 2, ly = (ph - lh) / 2;

    const img = draft ? DraftImage : letterHead ? LogoImage : null;

    if (!img) return;

    const isLarge = draft;
    const w = isLarge ? 450 : lw, h = isLarge ? 500 : lh;
    const x = isLarge ? dx : lx, y = isLarge ? dy : ly;

    doc.addImage(img, "PNG", x, y, w, h);
  } catch (e) {
    console.error("Error drawing watermark:", e);
  }
};

// Initialize header + footer layout on each page
export const initDefaultPage = (doc, observationSheet, letterHead) => {
  drawHeaderTable(doc, observationSheet);
  drawBorder(doc);
  drawWaterMarkImg(doc);
  drawFooterTable(doc, observationSheet);
};